import { SoundManager } from "./SoundManager";
import { LayaEnv } from "../../LayaEnv";
import { Component } from "../components/Component";
export class SoundPlayer extends Component {
    constructor() {
        super();
        this._loop = 1;
    }
    get source() {
        return this._source;
    }
    set source(value) {
        var _a;
        this._source = value;
        if (value) {
            if (((_a = this.owner) === null || _a === void 0 ? void 0 : _a.activeInHierarchy) && (this._autoPlay || this._channel) && LayaEnv.isPlaying)
                this.play(this._loop);
        }
        else
            this.stop();
    }
    get isMusic() {
        return this._isMusic;
    }
    set isMusic(value) {
        this._isMusic = value;
    }
    get loop() {
        return this._loop;
    }
    set loop(value) {
        this._loop = value;
    }
    get autoPlay() {
        return this._autoPlay;
    }
    set autoPlay(value) {
        var _a;
        this._autoPlay = value;
        if (((_a = this.owner) === null || _a === void 0 ? void 0 : _a.activeInHierarchy) && value && !this._channel && LayaEnv.isPlaying)
            this.play(this._loop);
    }
    play(loops, complete, startTime) {
        if (!this._source)
            return;
        if (loops == null || isNaN(loops))
            loops = this._loop;
        this.stop();
        if (this._isMusic)
            this._channel = SoundManager.playMusic(this._source, loops, complete, startTime);
        else
            this._channel = SoundManager.playSound(this._source, loops, complete, startTime);
    }
    stop() {
        if (this._channel)
            this._channel.stop();
        this._channel = null;
    }
    _onEnable() {
        if (this._autoPlay && !this._channel)
            this.play(this._loop);
        super._onEnable();
    }
    _onDisable() {
        this.stop();
        super._onDisable();
    }
}
